import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'
import styleB from '../../style'

import ScrollArea from '../../../partials/ScrollArea'

export const BillingTable = props => {
  const _report = [
    ...props.revenue.map(r => ({ ...r, _dType: 'revenue' })),
    ...props.transactions.map(t => ({ ...t, _dType: 'transactions' }))
  ].reduce((arr, item) => {
    const _iDateStr = item.date.split('-')
    _iDateStr[1] = +_iDateStr[1] - 1
    const _iDate = new Date(..._iDateStr)
    const currItemIndex = arr.findIndex(_item => {
      if (_item.date) {
        const __iDateStr = _item.date.split('-')
        __iDateStr[1] = +__iDateStr[1] - 1
        const __iDate = new Date(...__iDateStr)

        return (
          _iDate.getMonth() === __iDate.getMonth() &&
          _iDate.getFullYear() === __iDate.getFullYear()
        )
      }

      return false
    })

    return [
      ...(currItemIndex > -1
        ? [
          ...arr.slice(0, currItemIndex),
          {
            ...(item._dType === 'transactions'
                ? {
                  ...arr[currItemIndex],
                  transactions: [
                    ...(arr[currItemIndex].transactions || []),
                    item
                  ]
                }
                : {
                  ...item,
                  transactions: [...(arr[currItemIndex].transactions || [])]
                })
          },
          ...arr.slice(currItemIndex + 1)
        ]
        : [
          ...arr,
          {
            ...(item._dType === 'transactions'
                ? {
                  transactions: [item]
                }
                : {
                  ...item,
                  transactions: []
                })
          }
        ])
    ]
  }, [])

  return (
    <Row>
      <Col className={css(style.list.wrapper)}>
        <Row>
          <Col key={1}>
            <h3 className={css(styleB.headers.h3)}>Transactions</h3>
          </Col>
        </Row>
        <Row>
          <ScrollArea
            style={{
              height: `300px`
            }}
          >
            <Col>
              <Row
                className={css(
                  style.list.header,
                  style[props.theme.name]
                    ? style[props.theme.name].list.header
                    : null
                )}
              />
              {_report.map((item, index) => (
                <TransactionRow
                  theme={props.theme}
                  key={`${index}_${item.id}`}
                  report={item}
                  active={props.active}
                />
              ))}
            </Col>
          </ScrollArea>
        </Row>
      </Col>
    </Row>
  )
}

export const TransactionRow = props => {
  if (props.report.transactions.length > 0) {
    return props.report.transactions.map((t, index) => {
      const _date = t.date.split('-')
      _date[1] = +_date[1] - 1
      const date = new Date(..._date)

      return (
        <Row
          key={`${t.comId}_${index}`}
          data-tid={t.id}
          data-type={t._dType}
          className={css(
            style.list.row,
            style[props.theme.name] ? style[props.theme.name].list.row : null
          )}
        >
          <Col>
            <Row>
              <Col>
                <span
                  className={css(
                    style.transaction.span,
                    style.transaction.spanCenter,
                    style[props.theme.name]
                      ? style[props.theme.name].transaction.span
                      : null
                  )}
                >
                  {`${date.getMonth() +
                    1}/${date.getDate()}/${date.getFullYear()}`}
                </span>
              </Col>
              <Col>
                <span
                  className={css(
                    style.transaction.span,
                    style.transaction.spanCenter,
                    style[props.theme.name]
                      ? style[props.theme.name].transaction.span
                      : null
                  )}
                >
                  ${(+t.amount).toFixed(2)}
                </span>
              </Col>
              <Col className={`d-none d-lg-block`}>
                <span
                  className={css(
                    style.transaction.span,
                    style.transaction.spanCenter,
                    style[props.theme.name]
                      ? style[props.theme.name].transaction.span
                      : null
                  )}
                >
                  {t.type}
                </span>
              </Col>
              <Col
                className={`d-none d-lg-flex align-items-center justify-content-center`}
              >
                <span
                  className={css(style.status.label, style.status.completed)}
                >
                  completed
                </span>
              </Col>
            </Row>
          </Col>
          <Col xs='auto' className={`d-flex align-items-center`} />
        </Row>
      )
    })
  }

  const _date = props.report.date.split('-')
  _date[1] = +_date[1] - 1
  const date = new Date(..._date)
  date.setDate(1)

  return (
    <Row
      data-userid={props.id}
      data-tid={props.report.id}
      data-type={props.report._dType}
      className={css(style.list.row)}
    >
      <Col>
        <Row>
          <Col>
            <span
              className={css(
                style.transaction.span,
                style.transaction.spanCenter
              )}
            >
              {`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`}
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.transaction.span,
                style.transaction.spanCenter
              )}
            >
              ${(+props.report.total).toFixed(2)}
            </span>
          </Col>
          <Col className={`d-none d-lg-block`}>
            <span
              className={css(
                style.transaction.span,
                style.transaction.spanCenter
              )}
            >
              --
            </span>
          </Col>
          <Col
            className={`d-none d-lg-flex align-items-center justify-content-center`}
          >
            <span className={css(style.status.label, style.status.pending)}>
              pending
            </span>
          </Col>
        </Row>
      </Col>
      <Col xs='auto' className={`d-flex align-items-center`} />
    </Row>
  )
}

export default BillingTable



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/BillingTable/index.js